import React, { ReactNode } from 'react'
import { colors } from '../theme'
import { View, ViewStyle } from 'react-native'

interface Props {
  status?: 'info' | 'warning' | 'danger' | 'success'
  children: ReactNode
  containerStyle?: ViewStyle
  contentContainerStyle?: ViewStyle
}

function getColor(status) {
  if (status === 'warning') return colors.warning
  if (status === 'info') return colors.accentText
  if (status === 'danger') return colors.error
  if (status === 'success') return colors.success
  return colors.accentText
}

export const BtInfoCard = ({
  status,
  containerStyle,
  contentContainerStyle,
  children,
}: Props) => {
  const color = getColor(status)
  return (
    <View style={{ flexDirection: 'row' }}>
      <View
        style={[
          {
            height: '100%',
            width: 5,
            backgroundColor: color,
            borderTopLeftRadius: 5,
            borderBottomLeftRadius: 5,
          },
          containerStyle,
        ]}
      />
      <View style={[{ flex: 1, padding: 8 }, contentContainerStyle]}>
        {children}
      </View>
    </View>
  )
}
